import axios from 'axios';
import React, { useState } from 'react';
import { useQuery } from 'react-query';

export default function Brands() {
  const [brandd, setBrandModal] = useState(null);
  const [loading, setLoading] = useState(false);

  async function GetAllBrands() {
    setLoading(true);
    const { data } = await axios.get("https://ecommerce.routemisr.com/api/v1/brands");
    setLoading(false);
    return data;
  }

  const data  = useQuery('brands', GetAllBrands);

  return (
    <div className='container'>
      {loading ? (
        <div className="d-flex align-items-center justify-content-center my-5 py-5 text-center loader-row">
          <div className="col-auto">
            <div className ="preloader">
              <svg className ="cart" role="img" aria-label="Shopping cart line animation" viewBox="0 0 128 128" width="128px" height="128px" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="8">
                  <g className ="cart__track" stroke="hsla(0,10%,10%,0.1)">
                    <polyline points="4,4 21,4 26,22 124,22 112,64 35,64 39,80 106,80" />
                    <circle cx="43" cy="111" r="13" />
                    <circle cx="102" cy="111" r="13" />
                  </g>
                  <g className ="cart__lines" stroke="currentColor">
                    <polyline className ="cart__top" points="4,4 21,4 26,22 124,22 112,64 35,64 39,80 106,80" stroke-dasharray="338 338" stroke-dashoffset="-338" />
                    <g className ="cart__wheel1" transform="rotate(-90,43,111)">
                      <circle className ="cart__wheel-stroke" cx="43" cy="111" r="13" stroke-dasharray="81.68 81.68" stroke-dashoffset="81.68" />
                    </g>
                    <g className ="cart__wheel2" transform="rotate(90,102,111)">
                      <circle className ="cart__wheel-stroke" cx="102" cy="111" r="13" stroke-dasharray="81.68 81.68" stroke-dashoffset="81.68" />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
      ):
      
      <div className="row pt-3 g-4">
         <div className='row pt-5 g-4 text-center'>
        <h1 className='subtitle'>All Brands</h1>
      </div>
        {data?.data?.data.map((brand, index) => {
          return (
            <div key={index} className="col-md-3">
              <div className="card" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop" onClick={() => setBrandModal(brand)}>
                <div className="cardImg">
                  <img src={brand.image} alt={brand.name} />
                </div>
                <div className="cardBody text-center pb-3">
                  {brand.name}
                </div>
              </div>
            </div>
          );
        })}
      </div>
}
      <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5 subtitle" id="staticBackdropLabel">{brandd?.name}</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
             <div className="row">
              <div className="col-md-6"> <img src={brandd?.image} className='w-100'/></div>
             </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}